var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "calculator-form",
    { ref: "form", attrs: { title: _vm.title } },
    [
      _c(
        "template",
        { slot: "form" },
        [
          _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "" } },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "facade",
                        rawName: "v-facade",
                        value: "####-####",
                        expression: "'####-####'"
                      }
                    ],
                    staticClass: "title-branding custom-input",
                    attrs: {
                      label: "Government Employee Number",
                      type: "text",
                      filled: "",
                      rules: [
                        function(v) {
                          return !!v || "Government Employee Number is required"
                        },
                        function(v) {
                          return (
                            v.length === 9 ||
                            "Government Employee Number needs to be 8 digits long"
                          )
                        }
                      ],
                      disabled: _vm.checking
                    },
                    model: {
                      value: _vm.client.employee_number,
                      callback: function($$v) {
                        _vm.$set(_vm.client, "employee_number", $$v)
                      },
                      expression: "client.employee_number"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "" } },
                [
                  _c("v-autocomplete", {
                    staticClass: "title-branding custom-select",
                    attrs: {
                      items: _vm.types,
                      filter: _vm.typeFilter,
                      "item-text": "label",
                      "item-value": "id",
                      filled: "",
                      label: "Payroll",
                      rules: [
                        function(v) {
                          return !!v || "Payroll is required"
                        }
                      ],
                      disabled: _vm.checking
                    },
                    model: {
                      value: _vm.client.type,
                      callback: function($$v) {
                        _vm.$set(_vm.client, "type", $$v)
                      },
                      expression: "client.type"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-autocomplete", {
                    staticClass: "title-branding custom-select",
                    attrs: {
                      items: _vm.departments,
                      filter: _vm.typeFilter,
                      "item-text": "label",
                      "item-value": "id",
                      filled: "",
                      label: "Government Department",
                      rules: [
                        function(v) {
                          return !!v || "Government Department is required"
                        }
                      ],
                      disabled: _vm.checking
                    },
                    model: {
                      value: _vm.client.department,
                      callback: function($$v) {
                        _vm.$set(_vm.client, "department", $$v)
                      },
                      expression: "client.department"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "actions" },
        [
          _vm.kpError
            ? _c(
                "v-card-actions",
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "w-full title-branding caption",
                      attrs: { type: "error", icon: "$mdiAlert" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.kpError) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasResponse
            ? _c(
                "v-card-actions",
                { staticClass: "pb-0" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "w-full title-branding caption",
                      attrs: { type: _vm.alertColor, icon: _vm.alertIcon }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.alertMessage) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { class: _vm.isMobile ? "justify-space-between" : "" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "custom-button",
                  attrs: {
                    type: "button",
                    color: _vm.$vuetify.theme.dark
                      ? "primary lighten-1"
                      : "primary",
                    disabled: _vm.checking,
                    small: _vm.isMobile
                  },
                  on: { click: _vm.goBack }
                },
                [
                  _c("v-icon", { attrs: { dark: "", small: "" } }, [
                    _vm._v(
                      "\n                    $mdiChevronLeft\n                "
                    )
                  ]),
                  _vm._v("\n                Back\n            ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "primary--text custom-button",
                  attrs: {
                    color: "grey",
                    type: "button",
                    disabled: _vm.checking,
                    small: _vm.isMobile
                  },
                  on: { click: _vm.newQuote }
                },
                [_vm._v("\n                New quote\n            ")]
              ),
              _vm._v(" "),
              !_vm.isMobile ? _c("v-spacer") : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "custom-button",
                  attrs: {
                    type: "button",
                    color: "accent",
                    loading: _vm.checking,
                    small: _vm.isMobile
                  },
                  on: { click: _vm.validate }
                },
                [_vm._v("\n                Verify\n            ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }